import AnalysisDetails from './analysis.details';

export const AnalysisStores = {
  detail: AnalysisDetails,
};
